import { IResponseModel } from "../../IResponseModel";

export class RegisterResponse implements IResponseModel {
    token: string;
}